module.exports = __webpack_public_path__ + "static/Corprate_WhoWeAre_InternationalFranchises_01-3f36539ef10dbda7e64920c918649d84.jpg";